import { BlocksIconWarningCircle } from 'blocks-nextjs/blocks-web-components/components/icon/icons/warning-circle';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconWarningCircle = createComponent({
  react: React,
  tagName: 'cat-icon-warning-circle',
  elementClass: BlocksIconWarningCircle
});
